<form class="st:grid st:grid-cols-2 p-3 pt-7" [formGroup]="formGroup">
  <div class="st:border-r border-kz-light-blue-500 px-5">
    <div>{{ 'Personal information' | translate }}</div>
    <div class="flex flex-col mt-5">
      <div class="flex flex-row gap-2 items-top justify-end">
        <label for="gender" class="mt-2">{{ 'Gender' | translate }}</label>
        <div class="w-35">
          <app-selector
            placeholder="Gender"
            formControlName="gender"
            inputId="gender"
            valueContainerClass="h-8!"
            [options]="genderOptions"
            [errorMessage]="formGroup.controls.gender.touched ? formGroup.controls.gender.errors : null"
          />
        </div>
      </div>
      <div class="flex flex-row gap-2 items-top justify-end">
        <label for="firstName" class="mt-2">{{ 'First name' | translate }}</label>
        <div class="w-35">
          <input
            type="text"
            wrapperStyleClass="h-8!"
            titleCase
            kzInput
            formControlName="firstName"
            placeholder="First name"
            data-testid="res-tourist-edit-first-name"
            errorQa="res-tourist-edit-first-name-error"
            [errorMessage]="formGroup.controls.firstName.touched ? formGroup.controls.firstName.errors : null"
            [attr.id]="'firstName'"
          />
        </div>
      </div>
      <div class="flex flex-row gap-2 items-top justify-end">
        <label for="lastName" class="mt-2">{{ 'Last name' | translate }}</label>
        <div class="w-35">
          <input
            type="text"
            wrapperStyleClass="h-8!"
            titleCase
            kzInput
            formControlName="lastName"
            placeholder="Last name"
            data-testid="res-tourist-edit-last-name"
            errorQa="res-tourist-edit-last-name-error"
            [errorMessage]="formGroup.controls.lastName.touched ? formGroup.controls.lastName.errors : null"
            [attr.id]="'lastName'"
          />
        </div>
      </div>
      <div class="flex flex-row gap-2 items-top justify-end">
        <label for="birthDate" class="mt-2">{{ 'Birth date' | translate }}</label>
        <div class="w-35">
          <app-date-picker
            formControlName="birthDate"
            autoCompletePrefix="bday"
            wrapperStyleClass="h-8!"
            inputId="birthDate"
            iconClass="h-4! w-4! mt-1!"
            [errorMessage]="formGroup.controls.birthDate.touched ? formGroup.controls.birthDate.errors : null"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="px-5">
    <div>{{ 'Document' | translate }}</div>
    <div class="flex flex-col mt-5">
      <div class="flex flex-row gap-2 items-top justify-end">
        <label for="citizenshipCountryCode" class="mt-2">{{ 'Citizenship' | translate }}</label>
        <div class="w-35">
          <app-selector
            valueContainerClass="h-8!"
            formControlName="citizenshipCountryCode"
            optionLabel="countryName"
            optionValue="countryCode"
            placeholder="Citizenship"
            inputId="citizenshipCountryCode"
            [options]="countries()"
            [keepOptionsWhileLoading]="true"
            [disableTranslation]="true"
            [errorMessage]="
              formGroup.controls.citizenshipCountryCode.touched
                ? formGroup.controls.citizenshipCountryCode.errors
                : null
            "
          />
        </div>
      </div>
      <div class="flex flex-row gap-2 items-top justify-end">
        <label for="passportNumber" class="mt-2">{{ 'Passport number' | translate }}</label>
        <div class="w-35">
          <input
            type="text"
            wrapperStyleClass="h-8!"
            kzInput
            formControlName="passportNumber"
            placeholder="Passport number"
            [errorMessage]="formGroup.controls.passportNumber.touched ? formGroup.controls.passportNumber.errors : null"
            [attr.id]="'passportNumber'"
          />
        </div>
      </div>
      <div class="flex flex-row gap-2 items-top justify-end">
        <label for="passportExpiryDate" class="mt-2">{{ 'Expiration date' | translate }}</label>
        <div class="w-35">
          <app-date-picker
            formControlName="passportExpiryDate"
            autoCompletePrefix="passportExpiryDate"
            placeholder="Expiration date"
            wrapperStyleClass="h-8!"
            inputId="passportExpiryDate"
            iconClass="h-4! w-4! mt-1!"
            [errorMessage]="
              formGroup.controls.passportExpiryDate.touched ? formGroup.controls.passportExpiryDate.errors : null
            "
          />
        </div>
      </div>
    </div>
  </div>

  <ng-template #modalFooterTemplateRef>
    <div class="py-2 flex px-2 items-center justify-end gap-8">
      <button class="link-btn reverse-primary uppercase!" type="button" (click)="onDynamicModalClose()">
        {{ 'Close' | translate }}
      </button>
      <button mat-flat-button color="primary" class="h-9!" type="button">
        {{ 'Save' | translate }}
      </button>
    </div>
  </ng-template>
</form>
